import { useCollateralEntries } from '@hooks/other/useCollateralEntries';
import { useCredentialEntries } from '@hooks/other/useCredentialEntries';
import { useRegistryEntries } from '@hooks/other/useRegistryEntries';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import { ModuleRoute } from '../routes/types';

interface Entries {
  [key: string]: ModuleRoute[];
}

export const TabNavigation: React.FC = () => {
  const location = useLocation();
  const [currPath, setCurrPath] = React.useState('');
  const path = location.pathname.split('/');
  const module = path?.[1] || '';
  const registryEntries = useRegistryEntries();
  const credentialEntries = useCredentialEntries();
  const collateralEntries = useCollateralEntries();
  const entriesByModule: Entries = {
    registry: registryEntries,
    credential: credentialEntries,
    collateral: collateralEntries,
  };
  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setCurrPath(newValue);
  };

  React.useEffect(() => {
    setCurrPath(location.pathname);
  }, [location.pathname]);
  if (currPath === '') {
    return null;
  }
  if (entriesByModule[module] === undefined) {
    return null;
  }

  const filteredTabs = entriesByModule[module].filter((t) => t.path && t.label);
  return (
    <Tabs
      value={currPath}
      scrollButtons="auto"
      onChange={handleChange}
      allowScrollButtonsMobile
      variant="scrollable"
    >
      {filteredTabs.map((e) => (
        <Tab
          sx={{ textTransform: 'capitalize' }}
          component={Link}
          to={`/${module}/${e.path}`}
          value={`/${module}/${e.path}`}
          key={e.path}
          label={e.label}
        />
      ))}
    </Tabs>
  );
};
